class PageTitle {
  constructor(el, eventBus) {
    // console.log('PageTitle');
    this.el = el;
    this.eventBus = eventBus;
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.eventBus.subscribe('marker-over', this.show);
    this.eventBus.subscribe('marker-out', this.hide);
  }

  show(d) {
    this.el.classList.add('active');
    if (d.title) {
      this.el.innerHTML = this.template(d.title, d.comingSoon, d.isNextLocation);
    }
  }

  hide() {
    this.el.classList.remove('active');
    this.el.innerHTML = '';
  }

  selectTitle(title) {
    this.el.classList.add('active');
    this.el.innerHTML = title;
  }

  template(title, comingSoon = false, isNextLocation = false) {
    if (isNextLocation) {
      return `<h1>${title} <span>Up Next</span><h1>`
    } else if (comingSoon) {
      return `<h1>${title} <span>Coming Soon</span><h1>`
    } else {
      return `<h1>${title}<h1>`;
    }
  }
}

export default PageTitle;